import apiClient from './client';

/**
 * GET /api/cases
 * @param {Object} params - { status, risk_level, assigned_to, limit, offset }
 */
export const fetchCases = async (params = {}) => {
  const { data } = await apiClient.get('/api/cases', { params });
  return data; // { cases: CaseResponse[], total: number }
};

/**
 * GET /api/cases/:caseNumber
 */
export const fetchCase = async (caseNumber) => {
  const { data } = await apiClient.get(`/api/cases/${caseNumber}`);
  return data; // CaseResponse
};

/**
 * PATCH /api/cases/:caseNumber
 * @param {string} caseNumber
 * @param {Object} updates - { status?, assigned_to?, ai_summary?, ai_rating? }
 */
export const updateCase = async (caseNumber, updates) => {
  const { data } = await apiClient.patch(`/api/cases/${caseNumber}`, updates);
  return data; // CaseResponse
};
